import React, { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import queryString from "query-string";
import { useReportsActions, useSelectedBookmarkSelector, useUserActions } from "store";
import { IBookmark, QuickViewQueries, UrlQueryParams } from "store/types";

import { ReactComponent as BulletedList } from "../../assets/icons/bulleted-list-outline.svg";
import { GroupItem } from "./GroupItem";

export const QuickViewBookmark: React.FC<IBookmark> = ({
  params,
  name,
  id,
  is_default,
  is_private,
  account_default,
  user,
  type
}) => {
  const { push } = useHistory();
  const { pathname } = useLocation();

  const { setQuickViewQueriesAction } = useReportsActions();
  const selectedBookmark = useSelectedBookmarkSelector();
  const { setSelectedBookmark } = useUserActions();

  const filteredEmail = params.replace(/(email.+)\+/g, "%2B");
  const { quickViewQueries }: UrlQueryParams = queryString.parseUrl(filteredEmail).query;
  const bookmarkPath = params.split("?")[0];

  const handleClick = useCallback(() => {
    if (quickViewQueries) {
      setSelectedBookmark(id);
      setQuickViewQueriesAction({ queries: JSON.parse(quickViewQueries) as QuickViewQueries, replace: true });
      // If we're already on this page — don't push: it would replace location.search
      // with an empty string (bookmarkPath has no search params), which clears the URL.
      // The selectedBookmark effect in SmartSheetProvider handles the re-init instead.
      if (pathname !== bookmarkPath) {
        setTimeout(() => push(bookmarkPath), 0);
      }
    }
  }, [quickViewQueries, bookmarkPath, pathname, id]);

  const isActive = useMemo(() => selectedBookmark === id, [selectedBookmark, id]);

  return (
    <GroupItem
      icon={
        <MaterialTooltip isShow placement="top" title="Deal">
          <BulletedList style={{ fontSize: "18px" }} />
        </MaterialTooltip>
      }
      id={id}
      title={name}
      ownerData={user}
      isActive={isActive}
      onClick={handleClick}
      allowSetDefault
      isDefault={is_default}
      isPrivate={is_private}
      isAccountDefault={account_default}
      bookmarkType={type}
    />
  );
};
